"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="error-page">
      <div className="error-page-content">
        <h1 className="error-page-code">500</h1>
        <h2 className="error-page-title">Algo salió mal</h2>
        <p className="error-page-desc">{error.message || "Ha ocurrido un error inesperado."}</p>
        <button className="btn-primary" onClick={() => reset()} type="button">
          Intentar de nuevo
        </button>
      </div>
    </div>
  );
}
